export const formatConfirmationMessage = (
    messageTemplate: string | undefined | null,
    displayName: string | undefined | null,
    myAccountText: string | undefined | null,
    myAccountUrl: string | undefined | null
) => {
    return (messageTemplate || '')
        .replace('{FullName}', displayName || '')
        .replace(
            '{MyAccount}',
            `<a href="${myAccountUrl || ''}" data-qat="my-account-button" target="_blank">${myAccountText || ''}</a>`
        )
}
